import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'src/components/Modal'
import TableMui from 'src/components/TableMui'
import { selectInventoryProductDetails } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import * as S from './ModalInventoryDetails.styles'

export default ({
  open, setOpen, id, productCode,
}) => {
  const dispatch = useDispatch()
  const productDetails = useSelector(selectInventoryProductDetails)

  useEffect(() => {
    if (open && id && productCode) {
      dispatch(actions.getInventoryProductDetails({ inventoryId: id, productCode }))
    }
  }, [open, id, productCode, dispatch])

  const displayValue = (value: any) => {
    if (value === null || value === undefined || value === '') {
      return '-'
    }
    return String(value)
  }

  const renderProductInfo = () => {
    const tableColumns = [
      { id: 'enderecoGenerated', label: 'Endereço' },
      { id: 'firstCountOperatorName', label: '1ª Operador' },
      { id: 'firstCountQuantity', label: '1ª Contagem' },
      { id: 'firstCountDamage', label: '1ª Avaria' },
      { id: 'firstCountFinishedAt', label: 'Data 1ª Contagem' },
      { id: 'secondCountOperatorName', label: '2ª Operador' },
      { id: 'secondCountQuantity', label: '2ª Contagem' },
      { id: 'secondCountDamage', label: '2ª Avaria' },
      { id: 'secondCountFinishedAt', label: 'Data 2ª Contagem' },
      { id: 'thirdCountOperatorName', label: '3ª Operador' },
      { id: 'thirdCountQuantity', label: '3ª Contagem' },
      { id: 'thirdCountDamage', label: '3ª Avaria' },
      { id: 'thirdCountFinishedAt', label: 'Data 3ª Contagem' },
    ]
    if (!productDetails) return null

    const data = productDetails.data || productDetails

    const prepareTableRows = () => {
      if (!data.positions || !Array.isArray(data.positions)) return []

      return data.positions.map((position, index) => ({
        id: index,
        enderecoGenerated: displayValue(position.enderecoGenerated),
        firstCountDamage: displayValue(position.firstCountDamage),
        firstCountFinishedAt: displayValue(position.firstCountFinishedAt),
        firstCountOperatorName: displayValue(position.firstCountOperatorName),
        firstCountQuantity: displayValue(position.firstCountQuantity),
        firstCountStartedAt: displayValue(position.firstCountStartedAt),
        secondCountDamage: displayValue(position.secondCountDamage),
        secondCountFinishedAt: displayValue(position.secondCountFinishedAt),
        secondCountOperatorName: displayValue(position.secondCountOperatorName),
        secondCountQuantity: displayValue(position.secondCountQuantity),
        secondCountStartedAt: displayValue(position.secondCountStartedAt),
        thirdCountDamage: displayValue(position.thirdCountDamage),
        thirdCountFinishedAt: displayValue(position.thirdCountFinishedAt),
        thirdCountOperatorName: displayValue(position.thirdCountOperatorName),
        thirdCountQuantity: displayValue(position.thirdCountQuantity),
        thirdCountStartedAt: displayValue(position.thirdCountStartedAt),
      }))
    }

    const tableRows = prepareTableRows()

    return (
      <>
        <S.ProductInfoContainer>
          <S.ProductInfoGrid>
            <div>
              <S.ProductInfoLabel>Nome do Inventário:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.inventoryName)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>Descrição do Produto:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.descProduto)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>Código do Produto:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(productCode)}</S.ProductInfoValue>
            </div>
          </S.ProductInfoGrid>
          <S.ProductInfoRow>
            <div>
              <S.ProductInfoLabel>Estoque Inicial:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.initialStock)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>Valor Incremententado:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.incrementValue)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>Pedidos Pendentes:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.delayAdjustment)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>Total Contado:</S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.totalCounted)}</S.ProductInfoValue>
            </div>
            <div>
              <S.ProductInfoLabel>
                <S.InfoButton size={14} data-testid='detail-inventory-test' />
                <S.CellTolltip title='Total Ajustado = Total Contado - Estoque Inicial - Valor Incremento - Pedidos Pendentes' arrow>
                  <span>Total Ajustado:</span>
                </S.CellTolltip>
              </S.ProductInfoLabel>
              <S.ProductInfoValue>{displayValue(data?.totalAdjustment)}</S.ProductInfoValue>
            </div>
          </S.ProductInfoRow>
        </S.ProductInfoContainer>
        <S.TableWrapper>
          <S.CompactTableStyle>
            <div className='compact-table'>
              <TableMui
                columns={tableColumns}
                emptyLabel='Nenhuma posição encontrada'
                rows={tableRows}
                enablePagination
                rowsPerPageLimit={10}
              />
            </div>
          </S.CompactTableStyle>
        </S.TableWrapper>
      </>
    )
  }

  return (
    <Modal
      title={`Detalhes para produto: ${productCode}`}
      show={open}
      titleStyle={{ fontSize: '16px', letterSpacing: '1.5px' }}
      closedButton
      closeButtonAction={() => setOpen(false)}
      size='xl'
      body={(
        <div data-testid='modal-inventory-details'>
          {productCode && renderProductInfo()}
        </div>
      )}
    />
  )
}
